import { useCatalogSearch } from "@shared/hooks/useCatalogSearch/useCatalogSearch";
import { useSharedGlobalConfig } from "@shared/hooks/useSharedGlobalConfig/useSharedGlobalConfig";
import { isFullscriptJsVar } from "@shared/reactiveVar/useIsFullscriptJs/useIsFullscriptJs.store";
import { isInOfficeCheckoutVar } from "@shared/reactiveVar/useIsInOfficeCheckoutVar/useIsInOfficeCheckoutVar.store";

const useCatalogHideBrandsCheck = () => {
  const { searchStartedFromBrand } = useCatalogSearch();
  const { isClinic, isPatient, isEmerson } = useSharedGlobalConfig();

  if (isPatient) {
    return !!searchStartedFromBrand;
  }

  if (isClinic) {
    const isFullscriptJS = isFullscriptJsVar();
    const isInOfficeCheckout = isInOfficeCheckoutVar();

    return !!(searchStartedFromBrand && !isEmerson && !isInOfficeCheckout && !isFullscriptJS);
  }

  return false;
};

export { useCatalogHideBrandsCheck };
